/* eslint-disable max-len */
export default {
    name: 'PasswordReset',
    data() {
        return {
            dataForm: {
                email: undefined,
                is_backoffice: true
            },
            isLoading: false
        };
    },
    methods: {
        onSubmit() {
            this.isLoading = true;
            this.$usersService.requestPasswordUpdate(this.dataForm).then(() => {
                this.$bvToast.toast(`Revise la bandeja de entrada de su correo electrónico`, {
                    title: `Mensaje enviado`,
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                    variant: 'success'
                });
                this.loading = false;
            })
                .catch(err => {
                    this.$bvToast.toast(`${err.message}`, {
                        title: `Error ${err.name}`,
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                        variant: 'danger'
                    });
                    this.loading = false;
                });
        }
    }
};
